import { Alert, Skeleton } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { BrowserAccountDto } from "definitions/poizon-api";
import { useEffect } from "react";

import { ProfileCard } from "../../components";
import { NewClientWidget } from "./components/NewClientWidget/NewClientWidget";
import { UserClientWidget } from "./components/UserClient/UserClient";
import css from "./PoizonAccountsWidget.module.scss";
import { getPoizonClients } from "./store/fetchers/getUserPoizonClients";

export const PoizonAccountsWidget = () => {
  const [userClients] = useAtom(getPoizonClients.dataAtom);
  const [isLoading] = useAtom(getPoizonClients.isLoadingAtom);
  const getClients = useAction(getPoizonClients);
  useEffect(() => {
    getClients();
  }, [getClients]);

  if (isLoading && !userClients)
    return <Skeleton style={{ height: "200px" }} />;

  if (!userClients)
    return <Alert theme="danger" title="Ошибка получения данных" />;

  return (
    <ProfileCard title="Poizon аккаунты">
      <div className={css.grid}>
        {userClients.map((client: BrowserAccountDto, index) => {
          return (
            <UserClientWidget userClient={client} key={`userClient_${index}`} />
          );
        })}
        {userClients.length < 5 && <NewClientWidget />}
      </div>
    </ProfileCard>
  );
};
